module.exports = "/_next/static/images/4e766b18f4784752eff3a0e3bd2f77a4-Nubank_HickDuarte_58654 (2) 1_lg.jpg";